import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=bf0dfb26&scoped=true&"
import script from "./HistoryTable.vue?vue&type=script&lang=js&"
export * from "./HistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./HistoryTable.vue?vue&type=style&index=0&id=bf0dfb26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0dfb26",
  null
  
)

export default component.exports